<!-- 

This component is used to dynamically create upload (UpLoader.vue) components.
It needs a note id to know which note is responsible for handling the uploads.

Example usage:

<multi-uploader note-id="2"></multi-uploader>

 -->

<template>
  <div class="border-1">
    <div class="row p-3 justify-content-end">
      <div class="col-auto">
        <button @click="addUploader" class="btn btn-dark">Add a new document to the list</button>
      </div>
    </div>

    <div class="row form-control" style="margin: 0px !important;">
      <div v-for="uploader in uploaders" :key="uploader" class="col no-padding">
        <div class="mt-3 form-inline">
          <i class="material-icons text-primary pb-1">description</i>
          <button @click="deleteUploaderCheck(uploader)"text-color="white" class="mb-2 btn btn-warning font-size-075">REMOVE DOCUMENT</button>
        </div>

        <!-- <button @click="deleteUploaderCheck(uploader)"text-color="white" class="mb-2">REMOVE DOCUMENT</button> -->
        <up-loader
          v-on:updateloaders="loadUploaders" 
          :document-id="uploader" 
          :note-id="noteId">
        </up-loader>

        <hr class="mt-4 mb-4" />
      </div>
    </div>

    <!-- modal window for verifying module deletion -->
    <modal-window
    text-value="Delete Upload" 
    v-show="uploaderModalOpened"
    v-on:close-modal="closeUploaderModal"
    v-on:yes-click="deleteUploader"></modal-window>
  </div>
</template>

<script>
import axios from 'axios'
import UpLoader from './UpLoader'
import ModalWindow from '@/components/display-utils/ModalWindow.vue'

export default {
  components: {
    UpLoader,
    ModalWindow
  },
  data () {
    return {
      uploaders: [],
      uploaderForDeletion: 0,
      uploaderModalOpened: false
    }
  },
  props: { 
    noteId: {
      type: Number,
      default: 0
      }
  },
  mounted: function() {
    //called on launch
    this.loadUploaders()
  },
  methods: {
    loadUploaders: function() {
      let local = this

      //clear existing uploader components
      this.uploaders = []

      //make sure id is set before attempting to load
      if (this.noteId === 0) {
        return
      } 

      //ajax query
      axios({
          method: 'get',
          url: local.$helpers.api() + '/document/note/id/' + local.noteId,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'}
        })
        .then(function (res) {
          local.handleLoadRequest(res.data)
        })
        .catch(function (error) {
          console.log("error geting document data: ", error)
      });

    },

    handleLoadRequest: function(res) {
      for (var id in res) {
        this.uploaders.push(res[id])
      }
    },

    addUploader: function() {
      this.uploaders.push(0)
    },

    deleteUploaderCheck: function(id) {
      //since this is called during a for loop, we need to store
      //the id somewhere momentarily
      this.uploaderForDeletion = id
      this.uploaderModalOpened = true
    },

    closeUploaderModal: function() {
      this.uploaderModalOpened = false
      this.uploaderForDeletion = 0
    },

    deleteUploader: function(id) {
      let local = this
      let req = {}

      if (this.uploaderForDeletion === 0) {
        return 
      }

      req.id = this.uploaderForDeletion

      //ajax query
      axios({
        method: 'post',
        url: this.$helpers.api() + '/admin/document/delete',
        data: req,
        headers: {'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'application/json',
                  'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //refresh notes
          local.uploaderForDeletion = 0
          local.uploaderModalOpened = false
          local.loadUploaders()
        })
        .catch(function (error) {
          console.log("not logged in: ", error)
          local.uploaderForDeletion = 0
          local.uploaderModalOpened = false
        });
    }
  }
}

</script>

<style>
</style>